import Vue from 'vue'
import App from './App.vue'
import './animate.min.css'

  Vue.config.productionTip = false
import router from './router/index'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import './until'
new Vue({
  render: h => h(App),
  router,
}).$mount('#app')
